import { useState, useEffect, useCallback } from "react";

const STORAGE_KEY = "ems_recent_protocols";
const MAX_RECENT = 10;

export function useRecentHistory() {
  const [recentHistory, setRecentHistory] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    } catch {
      return [];
    }
  });

  const addToHistory = useCallback((protocol) => {
    if (!protocol?.id || !protocol?.name) return;
    setRecentHistory(prev => {
      const filtered = prev.filter(p => p.id !== protocol.id);
      const updated = [
        { id: protocol.id, name: protocol.name, service: protocol.service || "ground", viewedAt: new Date().toISOString() },
        ...filtered
      ].slice(0, MAX_RECENT);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated;
    });
  }, []);

  const clearHistory = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY);
    setRecentHistory([]);
  }, []);

  // Sync across tabs
  useEffect(() => {
    const handler = (e) => {
      if (e.key === STORAGE_KEY) {
        try { setRecentHistory(JSON.parse(e.newValue || "[]")); } catch {}
      }
    };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);

  return { recentHistory, addToHistory, clearHistory };
}
